import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
    on: {
        init: function () {
        renderNumbers1(this);
        },
        slideChange: function () {
        renderNumbers1(this);
        }
    }
}); 

// 自定义 01 02 03
function renderNumbers1(swiper) {
    const slides = swiper.wrapperEl.querySelectorAll(
        '.swiper-slide:not(.swiper-slide-duplicate)'
    );

    const total = slides.length;
    const current = swiper.realIndex;

    const format = (n) => (n + 1);
    let html = "";
    for (let i = 0; i < total; i++) {
        html += `<span class="num ${i === current ? "active" : ""}" data-index="${i}">
        ${format(i)}
        </span>`;
    }

  const container = document.querySelector(".banner .swiper-pagination.custom");
  container.innerHTML = html;

  // 点击跳转（关键点）
  container.querySelectorAll(".num").forEach(el => {
    el.onclick = () => {
      swiper.slideToLoop(parseInt(el.dataset.index));
    };
  });
}

$(".product-nav a").eq(0).addClass("active");
$(".product-list .product-content").eq(0).addClass("active");
$(".product-nav a").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".product-list .product-content").eq(index).addClass("active").siblings().removeClass("active");
})


var caseText = new Swiper(".section2 .swiper-text", {
    slideToClickedSlide: true, // 确保允许点击缩略图切换主图
    allowTouchMove: false,     // 【核心】禁用拖拽滑动，保留点击
    // 如果仍有问题，可尝试加入以下两个配置作为保险
    preventClicks: false,
    preventClicksPropagation: false,
    loop:true,
    breakpoints: {
        1280: {  //当屏幕宽度小于等于1280
            slidesPerView: 3,
        },
        768: {  //当屏幕宽度小于等于768
            slidesPerView: 2,
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 1,
        }
    },
});

var casePic = new Swiper(".section2 .swiper-pic", {
    effect: 'fade',
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
    },
    loop:true,//必须
    thumbs: {
        swiper: caseText,
    },
});

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
    if (s > $(".section3").offset().top - $(".section2").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };

$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s > $(".section3").offset().top - $(".section2").height() && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})
 

$(".section5 .pic img").eq(0).addClass("active");
$(".section5 .left .section-title").eq(0).addClass("active");
$(".application-nav ul li").eq(0).addClass("active");
$(".application-nav ul li").hover(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section5 .pic img").eq(index).addClass("active").siblings().removeClass("active");
    $(".section5 .left .section-title").eq(index).addClass("active").siblings().removeClass("active");
})


var Workshop = new Swiper(".section6 .mySwiper", {
    slidesPerView: 3,
    spaceBetween: 24,
    pagination: {
        el: ".section6 .swiper-pagination",
        clickable: true,
    },
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
	},
	speed:800,
    grid: {
        rows: 2,
        fill: 'column'
    },
  breakpoints: {
    // 屏幕宽度小于 600px 时，展示 1 列
    320: {
      slidesPerView: 2,
      spaceBetween: 10,
      grid: {
        rows: 1,
        fill: 'row'
      },
    },
    // 屏幕宽度小于 1024px 时，展示 2 列
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
    // 屏幕宽度大于 1024px 时，展示 5 列
    1025: {
      slidesPerView: 3,
      spaceBetween: 24,
      grid: {
        rows: 2,
        fill: 'row'
      },
    },
  },
});


